import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const TicketIcon = ({
  size = 32,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Ticket secondario / profondità */}
      <path
        d="
          M7.2 4.2
          H19
          C19.8 4.2 20.5 4.9 20.5 5.7
          V8.1
          C19.1 8.4 18 9.6 18 11
          C18 12.4 19.1 13.6 20.5 13.9
          V16.3
          C20.5 17.1 19.8 17.8 19 17.8
          H7.2
          Z
        "
        fill={GRAY}
        opacity="0.55"
      />

      {/* Ticket principale */}
      <path
        d="
          M4.5 5.5
          H17
          C17.8 5.5 18.5 6.2 18.5 7
          V8.5
          C16.9 8.7 15.7 10.1 15.7 11.8
          C15.7 13.5 16.9 14.9 18.5 15.1
          V17
          C18.5 17.8 17.8 18.5 17 18.5
          H4.5
          C3.7 18.5 3 17.8 3 17
          V15.1
          C4.6 14.9 5.8 13.5 5.8 11.8
          C5.8 10.1 4.6 8.7 3 8.5
          V7
          C3 6.2 3.7 5.5 4.5 5.5
          Z
        "
        fill={GOLD}
      />

      {/* Linea tratteggiata ticket */}
      <path
        d="M11 7.4V9.1M11 10.7V12.4M11 14V16.1"
        stroke="#202227"
        strokeWidth="1.15"
        strokeLinecap="round"
        opacity="0.65"
      />

      {/* Piccolo dettaglio */}
      <circle
        cx="8"
        cy="11.8"
        r="1.15"
        fill="#202227"
        opacity="0.7"
      />
    </svg>
  );
};

export default TicketIcon;